<template>
    <section class="characteristics">
        <div class="characteristics__content">
            <h4>{{ title }}</h4>
            <div class="characteristics__content__list">
                <!-- ITEM -->
                <div v-for="item in characteristics" :key="item.keyword" class="characteristics__content__list__item">
                    <div class="characteristics__content__list__item__left">
                        <span>{{ item.name }}</span>
                        <hr>
                    </div>
                    <span>{{ item.value }}</span>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { CharacteristicsItem } from './../../types' 
import VueTypes from 'vue-types'

export default {
    name: 'Characteristics',
    props: {
        title: VueTypes.string.isRequired,
        characteristics: VueTypes.arrayOf(CharacteristicsItem).def([]),
    }
}
</script>

<style lang="scss">
@import './styles.scss';
</style>
